import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Pagination,
  Drawer,
  Button,
  Form,
  Input,
  Switch,
  Popconfirm,
  Space,
  Select,
  Upload,
} from 'antd';
import { AgGridReact } from 'ag-grid-react';
import {
  DeleteOutlined,
  UploadOutlined,
  // PlusOutlined,
  // PlusSquareOutlined,
  // PlusCircleOutlined,
} from '@ant-design/icons';

import JoditEditor from '../../molecules/JoditEditor';
import SearchBar from '../../templates/SearchBar';
import StyledDrawer from '../../atoms/StyledDrawer';

const { Option } = Select;

function BannerView({
  form,
  list,
  paging,
  visible,
  selectedRows,
  isEdit,
  columnDefs,
  gridOptions,
  searchOption,
  bannerGroupId,
  bannerGroup,
  onBannerGroupId,
  onPaging,
  onRowClick,
  onCellClick,
  onGridReady,
  onDraw,
  onSelectionChanged,
  onFinish,
  onReset,
  onSearch,
  onDelete,
  onMoveList,
  onGridSizeChanged,
}) {
  return (
    <div>
      <Row>
        <Col span={24}>
          <Row style={{ marginBottom: 10 }}>
            <Col span={18} style={{ display: 'flex' }}>
              <Select
                value={bannerGroupId}
                onChange={value => onBannerGroupId(value)}
                dropdownMatchSelectWidth={false}
                style={{ width: '18rem', marginRight: '0.5rem' }}
              >
                <Option key="0" value="">
                  배너그룹을 선택하세요.
                </Option>
                {bannerGroup.map(item => (
                  <Option key={item.bannerGroupId} value={item.bannerGroupId}>
                    {item.bannerGroupNm}
                  </Option>
                ))}
              </Select>
              {/* SearchBar */}
              <SearchBar options={searchOption} onSearch={onSearch} />
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              <Space>
                <Button
                  type="primary"
                  // icon={<PlusCircleOutlined />}
                  onClick={() => {
                    onReset();
                    onDraw(true);
                  }}
                  ghost
                >
                  등록
                </Button>
                <Popconfirm
                  title="미사용 처리하시겠습니까?"
                  onConfirm={() => {
                    onDelete();
                  }}
                  onCancel={() => {}}
                  okText="저장"
                  cancelText="취소"
                  disabled={selectedRows.length < 1}
                >
                  <Button
                    type="danger"
                    htmlType="button"
                    disabled={selectedRows.length < 1}
                    icon={<DeleteOutlined />}
                  >
                    미사용
                  </Button>
                </Popconfirm>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="ag-theme-alpine" style={{ height: 470 }}>
            <AgGridReact
              rowData={list}
              columnDefs={columnDefs}
              {...gridOptions}
              onGridReady={onGridReady}
              onRowClicked={onRowClick}
              onCellClicked={onCellClick}
              onSelectionChanged={onSelectionChanged}
              onGridSizeChanged={onGridSizeChanged}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ padding: 20, textAlign: 'center' }}>
          <Pagination
            pageSize={paging?.pageSize ?? 10}
            current={paging?.currentPageNo ?? 1}
            total={paging?.totalRecordCount ?? 0}
            onChange={onPaging}
          />
        </Col>
      </Row>
      <StyledDrawer
        title={`상세배너 ${isEdit ? '수정' : '등록'}`}
        placement="right"
        width="40vw"
        open={visible}
        onClose={() => {
          onDraw(false);
          onMoveList();
        }}
        footer={[
          <Row align="middle" justify="space-between">
            <Col>
              <Button
                key="btn2"
                disabled={isEdit}
                htmlType="button"
                onClick={() => {
                  onReset(isEdit);
                }}
              >
                초기화
              </Button>
            </Col>
            <Col>
              <Space>
                <Popconfirm
                  key="btn1"
                  title="저장 하시겠습니까?"
                  placement="topRight"
                  onConfirm={() => {
                    form.submit();
                  }}
                  onCancel={() => {}}
                  okText="저장"
                  cancelText="취소"
                >
                  <Button
                    type="primary"
                    htmlType="button"
                    // onClick={() => form.submit()}
                  >
                    저장
                  </Button>
                </Popconfirm>
                <Button
                  key="btn3"
                  onClick={() => {
                    onDraw(false);
                    onMoveList();
                  }}
                >
                  닫기
                </Button>
              </Space>
            </Col>
          </Row>,
        ]}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          {/* Hidden Value */}
          <Form.Item name="bannerId" noStyle>
            <Input hidden />
          </Form.Item>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label="배너명"
                name="bannerNm"
                rules={[{ required: true, message: '배너명을 입력해주세요.' }]}
                tooltip="배너명을 입력해주세요."
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="배너그룹"
                name="bannerGroupId"
                rules={[
                  {
                    required: true,
                    message: '배너그룹을 선택해주세요.',
                  },
                ]}
                tooltip="배너그룹을 선택해주세요."
              >
                <Select>
                  <Option key="0" value="">
                    배너그룹을 선택해주세요.
                  </Option>
                  {bannerGroup.map(item => (
                    <Option key={item.bannerGroupId} value={item.bannerGroupId}>
                      {item.bannerGroupNm}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="링크URL"
                name="linkUrl"
                rules={[
                  {
                    required: true,
                    message: '링크URL을 입력해주세요.',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="정렬순서"
                name="sortOrdr"
                rules={[
                  {
                    required: true,
                    message: '정렬순서를 입력해주세요.',
                  },
                ]}
              >
                <Input type="number" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                shouldUpdate={(prevValues, curValues) =>
                  prevValues.atchFile !== curValues.atchFile
                }
                noStyle
              >
                {({ getFieldValue }) => {
                  const atchFile = getFieldValue('atchFile');
                  const disabled = atchFile && atchFile.length > 0;
                  /* eslint prefer-promise-reject-errors: "off" */
                  return (
                    <Form.Item
                      required
                      rules={[
                        () => ({
                          validator(_rule, value) {
                            if (!value || !value.length) {
                              return Promise.reject(
                                '배너 이미지를 추가해주세요.',
                              );
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                      name="atchFile"
                      label="첨부파일"
                      valuePropName="fileList"
                      getValueFromEvent={e => e.fileList}
                    >
                      <Upload
                        accept="image/*"
                        customRequest={data => {
                          setTimeout(() => {
                            data.onSuccess({ status: 'ok' }, null);
                          }, 0);
                        }}
                      >
                        <Button disabled={disabled}>
                          <UploadOutlined /> 클릭 업로드
                        </Button>
                      </Upload>
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="반영여부"
                name="reflctAt"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="사용여부" name="useAt" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="설명"
                name="bannerDc"
                rules={[{ required: true, message: '설명을 입력해주세요.' }]}
                tooltip="설명을 입력해주세요."
              >
                <JoditEditor
                  visible={visible}
                  removeButtons={['image']}
                  newConfig={{ height: 150 }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </StyledDrawer>
    </div>
  );
}

BannerView.propTypes = {
  form: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  ),
  list: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    ),
  ),
  paging: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
  visible: PropTypes.bool,
  columnDefs: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.object,
        PropTypes.func,
      ]),
    ),
  ),
  gridOptions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.func,
    PropTypes.object,
  ]),
  selectedRows: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  isEdit: PropTypes.bool,
  searchOption: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  ),
  bannerGroupId: PropTypes.string,
  bannerGroup: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  onBannerGroupId: PropTypes.func,
  onPaging: PropTypes.func,
  onGridReady: PropTypes.func,
  onRowClick: PropTypes.func,
  onCellClick: PropTypes.func,
  onDraw: PropTypes.func,
  onSelectionChanged: PropTypes.func,
  onFinish: PropTypes.func,
  onReset: PropTypes.func,
  onSearch: PropTypes.func,
  onDelete: PropTypes.func,
  onMoveList: PropTypes.func,
  onGridSizeChanged: PropTypes.func,
};

BannerView.defaultProps = {
  form: {},
  list: [],
  paging: {},
  visible: false,
  columnDefs: [],
  gridOptions: {},
  selectedRows: [],
  isEdit: false,
  searchOption: {},
  bannerGroupId: '',
  bannerGroup: [],
  onBannerGroupId: () => {},
  onPaging: () => {},
  onGridReady: () => {},
  onRowClick: () => {},
  onCellClick: () => {},
  onDraw: () => {},
  onSelectionChanged: () => {},
  onFinish: () => {},
  onReset: () => {},
  onSearch: () => {},
  onDelete: () => {},
  onMoveList: () => {},
  onGridSizeChanged: () => {},
};

export default BannerView;
